module.exports = __webpack_public_path__ + "img/vision3.a8b3c7bd.svg";